import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import { Button, Typography } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { useTranslation } from 'react-i18next';
import { InfoIcon } from '../CustomIcons';

const useStyles = makeStyles(theme => ({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  header: {
    fontSize: '16px',
    fontWeight: 700,
    marginTop: '16px',
    marginBottom: '16px'
  },
  body: {
    textAlign: 'center',
    padding: ' 0 16px',
    marginBottom: '16px'
  },
  button: {
    borderRadius: 32
  },
  closeButtonWrapper: {
    position: 'absolute',
    right: '15px',
    top: '15px',
    color: theme.palette.colorPalette[1],

    '&:hover': {
      cursor: 'pointer'
    }
  },
  infoModalContent: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}));

const InformationalModal = ({ onCloseModalCallback = () => {}, closeModal, header, content, buttonLabel = null }) => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  return (
    <div className={classes.infoModalContent}>
      <div className={classes.closeButtonWrapper} onClick={closeModal}>
        <HighlightOffIcon color="primary" />
      </div>
      <div className={classes.iconWrapper}>
        <InfoIcon />
      </div>
      <div>
        <Typography className={classes.header} variant="h4">
          {header}
        </Typography>
      </div>
      <div>
        <Typography className={classes.body} variant="body1">
          {content}
        </Typography>
      </div>
      <div>
        <Button
          onClick={async () => {
            await onCloseModalCallback();
            closeModal();
          }}
          className={classes.button}
          color="primary"
          variant="contained"
        >
          {buttonLabel ?? t('common:accept')}
        </Button>
      </div>
    </div>
  );
};

InformationalModal.propTypes = {
  closeModal: PropTypes.func,
  onCloseModalCallback: PropTypes.func,
  header: PropTypes.string,
  content: PropTypes.string
};

export default InformationalModal;
